<template>
  <transition name="fade">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="400"
      class="rounded-xl"
      scrollable
    >
      <v-card class="pb-5" rounded="lg">
        <v-card-title class="pt-1 pe-1">
          <v-spacer></v-spacer>
          <CloseBtn size="30" :callback="callbackClose" />
        </v-card-title>
        
        <v-card-text class="text-center">
            <AbstractAvatar
          :avatar="data.avatar"
          :height="120"
          :width="120"
          class="mx-auto d-flex align-center justify-center mb-2"
        ></AbstractAvatar>
          <div class="black--text">
            {{ data.Student ? data.Student.name : data.User.name }}
          </div>
          <div class="text-h6 brown--text">
            {{ $t("string.avatarLevel") }} {{ data.level }}
          </div>
          <div
            class="text-caption grey--text"
            style="font-weight: 100 !important"
          >
            {{ data.mochiId }}
          </div>

          <v-divider class="my-5" v-if="data.PlayerAchievement.length > 0"></v-divider>
          <div class="text-h6 mb-2" v-if="data.PlayerAchievement.length > 0">{{ $t("string.achievements") }}</div>
          <v-row>
            <v-col
              cols="4"
              v-for="item in data.PlayerAchievement"
              :key="item.achievementKey"
            >
              <v-img :src="item.AchievementLevel.imageUrl"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </transition>
</template>
  
  <script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    AbstractAvatar: () =>
      import(
        /* webpackChunkName: "component-abstract-avatar-testing" */ "@/components/avatar/AbstractAvatar"
      ),
  },
  props: ["showDialog", "callbackClose", "data"],
  computed: mapState({
    //
  }),
  data: () => ({
    //
  }),
  async mounted() {
    //
  },
  methods: {
    //
  },
};
</script>
  